import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';
import { HubDropdownMultiSelectComponent } from './dropdown-multi-select.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DirectivesModule
  ],
  exports: [
    HubDropdownMultiSelectComponent
  ],
  declarations: [
    HubDropdownMultiSelectComponent,
  ]
})

export class DropdownMultiSelectModule {}
